import { createSlice } from "@reduxjs/toolkit";
import { getAllBranches } from "./thunk"; // Import the async thunks

const initialState = {
  Branches: [],

  loading: false,
  error: null,
};

const BranchesSlice = createSlice({
  name: "BranchesSlice",
  initialState,
  reducers: {
  
  },
  extraReducers: (builder) => {
    builder

    // login
      .addCase(getAllBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.Branches = action.payload
      })
      .addCase(getAllBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });




  },
  

});

export default BranchesSlice.reducer;
